import { __ } from "@wordpress/i18n";
import {
  PanelBody,
  ToggleControl,
  TextControl,
  SelectControl,
} from "@wordpress/components";
import { SOCIAL_ICON_MAP } from "../social-icons";

const SOCIAL_LABELS = {
  twitter: "Twitter / X",
  facebook: "Facebook",
  linkedin: "LinkedIn",
  pinterest: "Pinterest",
  email: "Email",
  whatsapp: "WhatsApp",
};

export default function SettingsPanel({ attributes, setAttributes, showPopupInEditor, setShowPopupInEditor }) {
  const {
    displayMode = "popup",
    enableCopyLink = true,
    copyLinkText = "Copy link",
    socials = [],
  } = attributes;

  const updateSocial = (id, patch) => {
    setAttributes({
      socials: socials.map((s) => (s.id === id ? { ...s, ...patch } : s)),
    });
  };

  return (
    <>
      <PanelBody title={__("Display", "brandy-blocks")} initialOpen={true}>
        <SelectControl
          label={__("Display Mode", "brandy-blocks")}
          value={displayMode}
          options={[
            { label: __("Popup", "brandy-blocks"), value: "popup" },
            { label: __("Inline", "brandy-blocks"), value: "inline" },
          ]}
          onChange={(value) => setAttributes({ displayMode: value })}
        />
        {displayMode === "popup" && (
          <ToggleControl
            label={__("Show popup in editor", "brandy-blocks")}
            help={__("Preview only — not saved to the block.", "brandy-blocks")}
            checked={showPopupInEditor}
            onChange={setShowPopupInEditor}
          />
        )}
      </PanelBody>

      <PanelBody title={__("Copy Link", "brandy-blocks")} initialOpen={true}>
        <ToggleControl
          label={__("Enable Copy Link", "brandy-blocks")}
          checked={enableCopyLink}
          onChange={(value) => setAttributes({ enableCopyLink: value })}
        />
        {enableCopyLink && (
          <TextControl
            label={__("Copy Link Text", "brandy-blocks")}
            value={copyLinkText}
            onChange={(value) => setAttributes({ copyLinkText: value })}
          />
        )}
      </PanelBody>

      <PanelBody title={__("Social Networks", "brandy-blocks")} initialOpen={true}>
        {socials.map((social) => (
          <div
            key={social.id}
            style={{ marginBottom: "16px", borderBottom: "1px solid #e5e7eb", paddingBottom: "16px" }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "8px" }}>
              <span style={{ color: "#4b5563", display: "flex" }}>
                {SOCIAL_ICON_MAP[social.id]}
              </span>
              <strong style={{ fontSize: "13px" }}>{SOCIAL_LABELS[social.id]}</strong>
              <div style={{ marginLeft: "auto" }}>
                <ToggleControl
                  checked={social.enabled}
                  onChange={(value) => updateSocial(social.id, { enabled: value })}
                />
              </div>
            </div>
            {social.enabled && (
              <TextControl
                label={__("Button text", "brandy-blocks")}
                value={social.text}
                onChange={(value) => updateSocial(social.id, { text: value })}
              />
            )}
          </div>
        ))}
      </PanelBody>
    </>
  );
}
